import { Box } from "@outschool/backpack";
import { TrackingPageSection } from "@outschool/ui-legacy-component-library";
import React from "react";

import useBanners from "../hooks/useBanners";

export default function CategoryPageContentfulBanner({
  isFullWidth = false,
}: {
  isFullWidth?: boolean;
}) {
  const contentfulBanner = useBanners("CategoryPage", [], isFullWidth);

  return contentfulBanner ? (
    <TrackingPageSection
      name="category_page_contentful_banner"
      uniqueId="category_page_contentful_banner"
    >
      {setImpressionNode => (
        <Box ref={setImpressionNode}>
          <contentfulBanner.Component />
        </Box>
      )}
    </TrackingPageSection>
  ) : null;
}
